var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 29,
    viewBox: "0 0 46 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9954 0.89734C21.9036 0.89734 26.8118 0.91459 31.7194 0.88584C33.0672 0.87779 34.415 0.870315 35.7628 0.85364C35.8778 0.851915 35.9917 0.86859 36.1061 0.87894C36.6541 0.926665 36.7967 1.36481 36.9065 1.82654C38.0657 6.68126 37.6977 11.8517 35.6381 16.4177C35.0889 17.635 34.4185 18.7816 33.6773 19.8867C33.0948 20.7555 32.46 21.5853 31.7654 22.3707C31.2474 22.9566 30.7028 23.5161 30.125 24.0388C29.0376 25.0226 27.8836 25.9202 26.5381 26.5366C25.8245 26.8638 25.0765 27.0685 24.2979 27.1777C23.5217 27.287 22.742 27.2858 21.9634 27.2686C17.6601 27.1754 13.3568 27.2479 9.05351 27.2283C6.82596 27.2185 4.59784 27.226 2.37029 27.2283C2.13741 27.2283 1.90799 27.2099 1.68834 27.138C1.23179 26.9897 0.955212 26.5895 0.929337 26.0588C0.921862 25.9081 0.924162 25.7569 0.924162 25.6062C0.924162 17.8846 0.924162 10.1629 0.924162 2.44179C0.924162 2.22099 0.928762 2.00191 0.971887 1.78054C1.07596 1.25096 1.49686 0.93529 2.03104 0.90309C2.21676 0.89159 2.40364 0.896765 2.58994 0.896765C7.39176 0.896765 12.193 0.896765 16.9948 0.895615L16.9954 0.89734Z",
    fill: "#2F4653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7608 21.8428C37.0282 21.7704 37.2455 21.6174 37.4496 21.4541C38.3208 20.7584 38.9682 19.878 39.5208 18.9189C41.5126 15.4597 42.6856 11.5785 42.9156 7.5742C42.9392 7.16652 42.9415 6.76 42.9541 6.3529C42.9558 6.29252 42.9403 6.22812 42.9932 6.16257C43.1513 6.20857 43.2939 6.2862 43.4227 6.40005C44.9643 7.76625 45.2254 10.3606 45.0586 12.2783C44.663 16.8179 42.1566 21.6628 38.1322 24.0065C38.0396 24.0606 37.9459 24.1129 37.851 24.1635C37.2294 24.4953 36.5837 24.7558 35.919 24.9789C35.7936 25.0208 35.6683 25.0634 35.5441 25.1054C36.0921 25.0749 36.8499 24.9794 37.7084 24.6971C40.0038 23.9427 41.8323 22.2401 43.1019 20.2248C43.4141 19.7291 43.6941 19.2162 43.9678 18.6987C43.9845 18.6677 44.0012 18.6349 44.0437 18.6257C44.0943 18.6268 44.115 18.6671 44.1323 18.7068C44.77 20.1799 44.6055 21.6904 43.7068 23.0216C41.9375 25.6407 38.1989 27.2041 35.1071 27.2168C32.2574 27.2283 29.4083 27.2248 26.5586 27.2242C26.4689 27.2242 26.3326 27.2714 26.3079 27.1449C26.2814 27.0103 26.4269 27.0264 26.5103 26.9885C30.8337 25.0007 34.1049 21.5329 36.237 17.298C38.0896 13.618 39.0205 9.45272 38.6577 5.33342C38.5416 4.0138 38.2966 2.7051 37.92 1.43492C37.8976 1.35845 37.8659 1.2837 37.851 1.2055C37.7992 0.931797 37.8803 0.862797 38.1603 0.890397C38.8601 0.958822 39.4777 1.21815 40.0279 1.65112C41.0693 2.4705 41.4689 3.9563 41.7092 5.2052C42.1589 7.5443 41.6995 10.1352 41.1526 12.4237C40.4414 15.4022 39.2408 18.3129 37.5094 20.8458C37.3249 21.116 37.1115 21.3661 36.9132 21.626C36.8597 21.6962 36.8114 21.7698 36.7608 21.8417V21.8428Z",
    fill: "url(#paint0_linear_523_3660)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1217 12.0208C12.1171 11.6534 12.0032 11.2837 11.6789 11.0772C11.3633 10.8766 10.9435 10.8806 10.6951 11.1859C10.675 11.2106 10.6319 11.2526 10.6445 11.2888C10.6572 11.3251 10.7354 11.3164 10.7681 11.3331C10.8245 11.3613 10.8469 11.4176 10.8452 11.478C10.8429 11.5482 10.8423 12.218 10.8394 13.1415C10.027 13.1369 9.21391 13.1317 8.40143 13.1271C8.38591 12.9253 8.38016 12.6987 8.39453 12.4526C8.40776 12.2255 8.43708 11.9995 8.48136 11.7764C8.50091 11.6787 8.52333 11.5815 8.54863 11.4855C8.57623 11.3797 8.65271 11.2497 8.64466 11.1388C8.64351 11.1238 8.64006 11.1089 8.63086 11.0974C8.60901 11.0703 8.56703 11.0749 8.53368 11.0836C8.32668 11.1365 8.12543 11.2469 7.96673 11.39C7.91786 11.4337 7.78733 11.5579 7.66946 11.7695C7.35666 12.3296 7.33193 13.1231 7.33193 13.1231C7.31583 13.636 7.29571 14.6756 7.84253 15.7549C7.84253 15.7549 8.22548 16.5116 8.77346 16.6979C8.88156 16.7347 8.91088 16.7105 8.92008 16.6979C8.96263 16.6432 8.87121 16.5489 8.84418 16.507C8.79416 16.4299 8.75161 16.3483 8.71481 16.2637C8.63891 16.0895 8.58831 15.9049 8.55093 15.7192C8.43651 15.1534 8.36233 14.5807 8.37843 14.0028H10.8394V16.1746C10.8394 16.3184 10.8981 16.4569 11.0309 16.5248C11.1108 16.5656 11.2017 16.58 11.2908 16.5909C11.4466 16.6105 11.6059 16.6208 11.76 16.5909C11.8503 16.5737 11.9406 16.5409 12.0078 16.4782C12.1165 16.3776 12.1182 16.2407 12.1182 16.1033C12.1182 15.0125 12.1286 13.9218 12.1269 12.831C12.1269 12.5602 12.1246 12.2899 12.1217 12.0191V12.0208Z",
    fill: "url(#paint1_linear_523_3660)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74997 16.9697C7.75694 16.6794 7.36939 15.6271 7.15722 14.7146C7.11122 14.5156 7.06694 14.3196 7.04049 14.1166C6.96114 13.5031 6.96459 12.8286 7.16354 12.2363C7.01174 12.2703 6.94332 12.4008 6.85477 12.5066C6.53104 12.893 6.50574 13.3444 6.49022 13.7929C6.45342 14.8463 6.83809 15.5955 6.92377 15.7565C7.11697 16.1182 7.32742 16.3562 7.38952 16.4246C7.61032 16.669 7.83227 16.8386 8.00247 16.9513C7.86734 16.918 7.67644 16.8553 7.47232 16.7294C7.28314 16.6127 7.14802 16.4827 7.05947 16.3832C6.93124 16.2194 6.84097 16.075 6.78232 15.9727C6.62419 15.699 6.42754 15.358 6.32749 14.9009C6.29932 14.7727 6.28034 14.6421 6.22974 14.637C6.15672 14.6295 6.07449 14.8894 6.05667 14.9452C5.99917 15.1263 5.98479 15.2936 5.98537 15.3822C5.98939 15.7272 6.24814 16.3982 6.86627 16.8536C6.86627 16.8536 7.40677 17.2515 8.33137 17.282C8.36932 17.2831 8.59299 17.2779 8.75917 17.1589C8.84082 17.1003 8.89487 17.0106 8.74997 16.9686V16.9697Z",
    fill: "url(#paint2_linear_523_3660)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16343 12.2324C7.16343 12.2324 7.16277 12.2351 7.16211 12.2364C7.16343 12.2364 7.16476 12.2357 7.16608 12.2351L7.16343 12.2324Z",
    fill: "url(#paint3_linear_523_3660)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16406 12.2338L7.16691 12.2367L7.17832 12.2207L7.16406 12.2338Z",
    fill: "url(#paint4_linear_523_3660)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8296 11.8913C24.8336 11.7648 24.8296 11.5774 24.7842 11.352C24.7796 11.3278 24.7738 11.2703 24.7445 11.2036C24.729 11.1674 24.6853 11.0714 24.5835 11.0058C24.5289 10.9713 24.4679 10.9506 24.4035 10.9512C24.3587 10.9512 24.3138 10.9546 24.2696 10.9546C24.2075 10.9546 24.1454 10.9564 24.0833 10.9569C23.9625 10.9581 23.8418 10.9552 23.7216 10.9598C23.6135 10.9638 23.5123 11.0006 23.4352 11.0817C23.3438 11.1777 23.2708 11.3146 23.15 11.6078C23.1299 11.6561 23.1138 11.6975 23.1029 11.7257C23.0569 11.8252 22.4077 13.2328 22.1622 13.6399C22.1444 13.6704 22.1041 13.7353 22.0547 13.733C22.0046 13.7353 21.965 13.6704 21.9471 13.6399C21.7022 13.2322 21.0524 11.8252 21.0064 11.7257C20.9955 11.6975 20.9794 11.6567 20.9593 11.6078C20.8385 11.3146 20.7655 11.1777 20.6741 11.0817C20.5976 11.0006 20.4964 10.9638 20.3877 10.9598C20.267 10.9558 20.1462 10.9581 20.0261 10.9569C19.964 10.9569 19.9019 10.9552 19.8398 10.9546C19.7949 10.9546 19.7501 10.9518 19.7058 10.9512C19.6414 10.9512 19.581 10.9713 19.5258 11.0058C19.424 11.0714 19.3803 11.1674 19.3648 11.2036C19.3355 11.2703 19.3297 11.3278 19.3251 11.352C19.2803 11.5779 19.2757 11.7654 19.2797 11.8913C19.2326 13.3397 19.1854 14.787 19.1377 16.2354C19.1394 16.2596 19.144 16.2929 19.1572 16.3303C19.2314 16.5425 19.5005 16.6466 19.7075 16.6494C19.9168 16.6523 20.1669 16.5528 20.2555 16.3608C20.2566 16.3585 20.2727 16.3211 20.2814 16.2797C20.3429 15.9847 20.3785 13.6094 20.3918 12.575C20.9587 13.7365 21.402 14.6047 21.6073 14.9877C21.6487 15.0665 21.7378 15.2246 21.9017 15.2786C21.9489 15.2947 22.0012 15.3034 22.0547 15.3039C22.1081 15.3039 22.1605 15.2947 22.2076 15.2786C22.3715 15.2246 22.46 15.0665 22.502 14.9877C22.7067 14.6047 23.1506 13.7365 23.7176 12.575C23.7308 13.61 23.7664 15.9847 23.828 16.2797C23.8366 16.3211 23.8527 16.3585 23.8538 16.3608C23.9424 16.5528 24.1925 16.6523 24.4018 16.6494C24.6094 16.6466 24.8779 16.5425 24.9521 16.3303C24.9653 16.2929 24.9699 16.2596 24.9716 16.2354C24.9245 14.787 24.8773 13.3397 24.8296 11.8913V11.8913Z",
    fill: "url(#paint5_linear_523_3660)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0078 11.1247C17.89 10.9757 17.6887 10.97 17.4949 10.9648C17.3115 10.9596 17.0781 10.9533 16.932 11.1155C16.8509 11.2057 16.8285 11.3121 16.8216 11.3765C16.8182 12.4454 16.8147 13.5138 16.8113 14.5827C16.813 14.6874 16.8026 14.8846 16.6968 15.1014C16.5853 15.3302 16.4272 15.4602 16.3869 15.4918C16.3869 15.4918 16.1178 15.7045 15.7659 15.7327C15.7308 15.7356 15.6935 15.7367 15.6935 15.7367C15.6843 15.7367 15.6751 15.7367 15.6659 15.7373C15.6567 15.7373 15.6475 15.7373 15.6383 15.7367C15.6383 15.7367 15.6015 15.7356 15.5658 15.7327C15.2139 15.704 14.9448 15.4918 14.9448 15.4918C14.904 15.4596 14.7464 15.3302 14.6349 15.1014C14.5291 14.8846 14.5187 14.6874 14.5205 14.5827C14.517 13.5138 14.5136 12.4454 14.5101 11.3765C14.5032 11.3121 14.4814 11.2057 14.3997 11.1155C14.2537 10.9533 14.0202 10.9596 13.8368 10.9648C13.6436 10.97 13.4418 10.9757 13.3239 11.1247C13.2313 11.2414 13.2388 11.3857 13.2463 11.4484V14.8041C13.2463 15.1163 13.336 15.5297 13.6355 15.9225C13.9719 16.3635 14.4497 16.5601 14.5969 16.6148C14.8954 16.7257 15.1892 16.7568 15.2789 16.7654C15.4347 16.7809 15.5675 16.7815 15.6659 16.7786C15.7642 16.7815 15.897 16.7809 16.0528 16.7654C16.1425 16.7562 16.4364 16.7252 16.7348 16.6148C16.882 16.5601 17.3598 16.3635 17.6962 15.9225C17.9952 15.5297 18.0855 15.1163 18.0855 14.8041V11.4484C18.0929 11.3857 18.1004 11.2414 18.0078 11.1247V11.1247Z",
    fill: "url(#paint6_linear_523_3660)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3232 12.7375C31.161 12.1987 30.8298 11.7238 30.3802 11.3857C29.8701 11.0027 29.2377 10.8021 28.6023 10.7871C27.9669 10.8021 27.3344 11.0027 26.8244 11.3857C26.3742 11.7238 26.043 12.1987 25.8814 12.7375C25.4185 14.2843 26.1148 16.2577 27.7812 16.6941C28.0503 16.7642 28.3269 16.7941 28.6023 16.7867C28.8783 16.7941 29.1549 16.7642 29.4234 16.6941C31.0897 16.2577 31.7861 14.2843 31.3232 12.7375V12.7375ZM30.0858 14.4642C29.9116 15.1968 29.4251 15.984 28.6017 15.9926C27.7783 15.984 27.2919 15.1968 27.1176 14.4642C26.9497 13.7587 26.9808 12.9278 27.3758 12.2982C27.6495 11.8618 28.1153 11.6036 28.6011 11.6002C29.0876 11.6036 29.5527 11.8624 29.8264 12.2982C30.2215 12.9278 30.2525 13.7587 30.0846 14.4642H30.0858Z",
    fill: "url(#paint7_linear_523_3660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_523_3660",
    x1: 24.2195,
    y1: 18.0737,
    x2: 45.6221,
    y2: 11.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_523_3660",
    x1: 10.9441,
    y1: 14.46,
    x2: 7.00246,
    y2: 11.4774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_523_3660",
    x1: 9.47159,
    y1: 16.4045,
    x2: 5.52997,
    y2: 13.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_523_3660",
    x1: 11.1648,
    y1: 15.2632,
    x2: 6.62418,
    y2: 11.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_523_3660",
    x1: 10.6149,
    y1: 14.8339,
    x2: 6.70677,
    y2: 11.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_523_3660",
    x1: 25.5449,
    y1: 15.6754,
    x2: 19.4194,
    y2: 12.4266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_523_3660",
    x1: 18.6817,
    y1: 15.3756,
    x2: 12.5563,
    y2: 11.5404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_523_3660",
    x1: 32.9228,
    y1: 16.3111,
    x2: 25.3064,
    y2: 11.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0DE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DECB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C0AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B39F4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumo);
export default __webpack_public_path__ + "static/media/humo.5c8a780e27dc6faaea7677d959775eae.svg";
export { ForwardRef as ReactComponent };